module.exports = __webpack_public_path__ + "img/9788936456108.b6274414.jpg";